import { useNavigate } from "react-router";
import { useDeleteAccount } from "../hooks/useAccount";
import Button from "./Button";
import Dialog from "./Dialog";

interface Props {
  accountId: string;
  open: boolean;
  onClose: () => void;
}

const DeleteAccountDialog = ({ accountId, open, onClose }: Props) => {
  const navigate = useNavigate();
  const mutation = useDeleteAccount();

  return (
    <Dialog
      open={open}
      size="small"
      onClose={() => {
        mutation.reset();
        onClose();
      }}
    >
      <Dialog.Title>Delete account?</Dialog.Title>
      <Dialog.Content>
        All information related to this account will be deleted immediately.
        This action cannot be undone.
      </Dialog.Content>
      <Dialog.Footer>
        <Button
          type="secondary"
          buttonProps={{
            onClick: onClose,
          }}
        >
          Cancel
        </Button>
        <Button
          isLoading={mutation.isPending}
          buttonProps={{
            type: "submit",
            disabled: mutation.isPending,
            onClick: () => {
              mutation.mutate(accountId, {
                onSuccess: () => {
                  onClose();
                  navigate("/login");
                },
              });
            },
          }}
        >
          Delete
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};

export default DeleteAccountDialog;
